import React from "react";

const TestServerQR1 = () => {
  return (
    <div className="text-center">
      <svg
        width="200"
        height="200"
        viewBox="0 0 1147 1147"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1147 0H0V1147H1147V0Z" fill="white" />
        <path d="M341 93H310V124H341V93Z" fill="black" />
        <path d="M434 93H403V124H434V93Z" fill="black" />
        <path d="M496 93H465V124H496V93Z" fill="black" />
        <path d="M527 93H496V124H527V93Z" fill="black" />
        <path d="M589 93H558V124H589V93Z" fill="black" />
        <path d="M651 93H620V124H651V93Z" fill="black" />
        <path d="M682 93H651V124H682V93Z" fill="black" />
        <path d="M837 93H806V124H837V93Z" fill="black" />
        <path d="M341 124H310V155H341V124Z" fill="black" />
        <path d="M372 124H341V155H372V124Z" fill="black" />
        <path d="M403 124H372V155H403V124Z" fill="black" />
        <path d="M434 124H403V155H434V124Z" fill="black" />
        <path d="M465 124H434V155H465V124Z" fill="black" />
        <path d="M496 124H465V155H496V124Z" fill="black" />
        <path d="M527 124H496V155H527V124Z" fill="black" />
        <path d="M558 124H527V155H558V124Z" fill="black" />
        <path d="M589 124H558V155H589V124Z" fill="black" />
        <path d="M713 124H682V155H713V124Z" fill="black" />
        <path d="M744 124H713V155H744V124Z" fill="black" />
        <path d="M806 124H775V155H806V124Z" fill="black" />
        <path d="M372 155H341V186H372V155Z" fill="black" />
        <path d="M527 155H496V186H527V155Z" fill="black" />
        <path d="M589 155H558V186H589V155Z" fill="black" />
        <path d="M651 155H620V186H651V155Z" fill="black" />
        <path d="M713 155H682V186H713V155Z" fill="black" />
        <path d="M775 155H744V186H775V155Z" fill="black" />
        <path d="M806 155H775V186H806V155Z" fill="black" />
        <path d="M837 155H806V186H837V155Z" fill="black" />
        <path d="M341 186H310V217H341V186Z" fill="black" />
        <path d="M372 186H341V217H372V186Z" fill="black" />
        <path d="M403 186H372V217H403V186Z" fill="black" />
        <path d="M465 186H434V217H465V186Z" fill="black" />
        <path d="M496 186H465V217H496V186Z" fill="black" />
        <path d="M558 186H527V217H558V186Z" fill="black" />
        <path d="M589 186H558V217H589V186Z" fill="black" />
        <path d="M744 186H713V217H744V186Z" fill="black" />
        <path d="M775 186H744V217H775V186Z" fill="black" />
        <path d="M806 186H775V217H806V186Z" fill="black" />
        <path d="M372 217H341V248H372V217Z" fill="black" />
        <path d="M496 217H465V248H496V217Z" fill="black" />
        <path d="M527 217H496V248H527V217Z" fill="black" />
        <path d="M558 217H527V248H558V217Z" fill="black" />
        <path d="M589 217H558V248H589V217Z" fill="black" />
        <path d="M620 217H589V248H620V217Z" fill="black" />
        <path d="M682 217H651V248H682V217Z" fill="black" />
        <path d="M775 217H744V248H775V217Z" fill="black" />
        <path d="M837 217H806V248H837V217Z" fill="black" />
        <path d="M341 248H310V279H341V248Z" fill="black" />
        <path d="M403 248H372V279H403V248Z" fill="black" />
        <path d="M465 248H434V279H465V248Z" fill="black" />
        <path d="M527 248H496V279H527V248Z" fill="black" />
        <path d="M589 248H558V279H589V248Z" fill="black" />
        <path d="M651 248H620V279H651V248Z" fill="black" />
        <path d="M713 248H682V279H713V248Z" fill="black" />
        <path d="M775 248H744V279H775V248Z" fill="black" />
        <path d="M837 248H806V279H837V248Z" fill="black" />
        <path d="M372 279H341V310H372V279Z" fill="black" />
        <path d="M496 279H465V310H496V279Z" fill="black" />
        <path d="M527 279H496V310H527V279Z" fill="black" />
        <path d="M558 279H527V310H558V279Z" fill="black" />
        <path d="M589 279H558V310H589V279Z" fill="black" />
        <path d="M775 279H744V310H775V279Z" fill="black" />
        <path d="M806 279H775V310H806V279Z" fill="black" />
        <path d="M93 310H62V341H93V310Z" fill="black" />
        <path d="M186 310H155V341H186V310Z" fill="black" />
        <path d="M217 310H186V341H217V310Z" fill="black" />
        <path d="M248 310H217V341H248V310Z" fill="black" />
        <path d="M279 310H248V341H279V310Z" fill="black" />
        <path d="M310 310H279V341H310V310Z" fill="black" />
        <path d="M341 310H310V341H341V310Z" fill="black" />
        <path d="M403 310H372V341H403V310Z" fill="black" />
        <path d="M527 310H496V341H527V310Z" fill="black" />
        <path d="M589 310H558V341H589V310Z" fill="black" />
        <path d="M620 310H589V341H620V310Z" fill="black" />
        <path d="M713 310H682V341H713V310Z" fill="black" />
        <path d="M806 310H775V341H806V310Z" fill="black" />
        <path d="M837 310H806V341H837V310Z" fill="black" />
        <path d="M868 310H837V341H868V310Z" fill="black" />
        <path d="M961 310H930V341H961V310Z" fill="black" />
        <path d="M1023 310H992V341H1023V310Z" fill="black" />
        <path d="M1054 310H1023V341H1054V310Z" fill="black" />
        <path d="M1085 310H1054V341H1085V310Z" fill="black" />
        <path d="M93 341H62V372H93V341Z" fill="black" />
        <path d="M155 341H124V372H155V341Z" fill="black" />
        <path d="M186 341H155V372H186V341Z" fill="black" />
        <path d="M217 341H186V372H217V341Z" fill="black" />
        <path d="M341 341H310V372H341V341Z" fill="black" />
        <path d="M372 341H341V372H372V341Z" fill="black" />
        <path d="M465 341H434V372H465V341Z" fill="black" />
        <path d="M496 341H465V372H496V341Z" fill="black" />
        <path d="M527 341H496V372H527V341Z" fill="black" />
        <path d="M558 341H527V372H558V341Z" fill="black" />
        <path d="M620 341H589V372H620V341Z" fill="black" />
        <path d="M651 341H620V372H651V341Z" fill="black" />
        <path d="M682 341H651V372H682V341Z" fill="black" />
        <path d="M744 341H713V372H744V341Z" fill="black" />
        <path d="M806 341H775V372H806V341Z" fill="black" />
        <path d="M837 341H806V372H837V341Z" fill="black" />
        <path d="M961 341H930V372H961V341Z" fill="black" />
        <path d="M992 341H961V372H992V341Z" fill="black" />
        <path d="M1023 341H992V372H1023V341Z" fill="black" />
        <path d="M155 372H124V403H155V372Z" fill="black" />
        <path d="M186 372H155V403H186V372Z" fill="black" />
        <path d="M279 372H248V403H279V372Z" fill="black" />
        <path d="M372 372H341V403H372V372Z" fill="black" />
        <path d="M496 372H465V403H496V372Z" fill="black" />
        <path d="M558 372H527V403H558V372Z" fill="black" />
        <path d="M775 372H744V403H775V372Z" fill="black" />
        <path d="M806 372H775V403H806V372Z" fill="black" />
        <path d="M837 372H806V403H837V372Z" fill="black" />
        <path d="M868 372H837V403H868V372Z" fill="black" />
        <path d="M961 372H930V403H961V372Z" fill="black" />
        <path d="M992 372H961V403H992V372Z" fill="black" />
        <path d="M1023 372H992V403H1023V372Z" fill="black" />
        <path d="M1085 372H1054V403H1085V372Z" fill="black" />
        <path d="M124 403H93V434H124V403Z" fill="black" />
        <path d="M155 403H124V434H155V403Z" fill="black" />
        <path d="M186 403H155V434H186V403Z" fill="black" />
        <path d="M372 403H341V434H372V403Z" fill="black" />
        <path d="M403 403H372V434H403V403Z" fill="black" />
        <path d="M434 403H403V434H434V403Z" fill="black" />
        <path d="M496 403H465V434H496V403Z" fill="black" />
        <path d="M558 403H527V434H558V403Z" fill="black" />
        <path d="M651 403H620V434H651V403Z" fill="black" />
        <path d="M713 403H682V434H713V403Z" fill="black" />
        <path d="M744 403H713V434H744V403Z" fill="black" />
        <path d="M775 403H744V434H775V403Z" fill="black" />
        <path d="M806 403H775V434H806V403Z" fill="black" />
        <path d="M930 403H899V434H930V403Z" fill="black" />
        <path d="M1023 403H992V434H1023V403Z" fill="black" />
        <path d="M1085 403H1054V434H1085V403Z" fill="black" />
        <path d="M124 434H93V465H124V434Z" fill="black" />
        <path d="M186 434H155V465H186V434Z" fill="black" />
        <path d="M248 434H217V465H248V434Z" fill="black" />
        <path d="M279 434H248V465H279V434Z" fill="black" />
        <path d="M372 434H341V465H372V434Z" fill="black" />
        <path d="M496 434H465V465H496V434Z" fill="black" />
        <path d="M558 434H527V465H558V434Z" fill="black" />
        <path d="M620 434H589V465H620V434Z" fill="black" />
        <path d="M682 434H651V465H682V434Z" fill="black" />
        <path d="M744 434H713V465H744V434Z" fill="black" />
        <path d="M806 434H775V465H806V434Z" fill="black" />
        <path d="M837 434H806V465H837V434Z" fill="black" />
        <path d="M899 434H868V465H899V434Z" fill="black" />
        <path d="M930 434H899V465H930V434Z" fill="black" />
        <path d="M93 465H62V496H93V465Z" fill="black" />
        <path d="M124 465H93V496H124V465Z" fill="black" />
        <path d="M155 465H124V496H155V465Z" fill="black" />
        <path d="M186 465H155V496H186V465Z" fill="black" />
        <path d="M372 465H341V496H372V465Z" fill="black" />
        <path d="M403 465H372V496H403V465Z" fill="black" />
        <path d="M496 465H465V496H496V465Z" fill="black" />
        <path d="M527 465H496V496H527V465Z" fill="black" />
        <path d="M651 465H620V496H651V465Z" fill="black" />
        <path d="M682 465H651V496H682V465Z" fill="black" />
        <path d="M713 465H682V496H713V465Z" fill="black" />
        <path d="M837 465H806V496H837V465Z" fill="black" />
        <path d="M868 465H837V496H868V465Z" fill="black" />
        <path d="M930 465H899V496H930V465Z" fill="black" />
        <path d="M992 465H961V496H992V465Z" fill="black" />
        <path d="M93 496H62V527H93V496Z" fill="black" />
        <path d="M124 496H93V527H124V496Z" fill="black" />
        <path d="M217 496H186V527H217V496Z" fill="black" />
        <path d="M279 496H248V527H279V496Z" fill="black" />
        <path d="M372 496H341V527H372V496Z" fill="black" />
        <path d="M403 496H372V527H403V496Z" fill="black" />
        <path d="M465 496H434V527H465V496Z" fill="black" />
        <path d="M527 496H496V527H527V496Z" fill="black" />
        <path d="M558 496H527V527H558V496Z" fill="black" />
        <path d="M651 496H620V527H651V496Z" fill="black" />
        <path d="M682 496H651V527H682V496Z" fill="black" />
        <path d="M713 496H682V527H713V496Z" fill="black" />
        <path d="M744 496H713V527H744V496Z" fill="black" />
        <path d="M775 496H744V527H775V496Z" fill="black" />
        <path d="M837 496H806V527H837V496Z" fill="black" />
        <path d="M899 496H868V527H899V496Z" fill="black" />
        <path d="M93 527H62V558H93V527Z" fill="black" />
        <path d="M155 527H124V558H155V527Z" fill="black" />
        <path d="M217 527H186V558H217V527Z" fill="black" />
        <path d="M248 527H217V558H248V527Z" fill="black" />
        <path d="M310 527H279V558H310V527Z" fill="black" />
        <path d="M403 527H372V558H403V527Z" fill="black" />
        <path d="M496 527H465V558H496V527Z" fill="black" />
        <path d="M589 527H558V558H589V527Z" fill="black" />
        <path d="M713 527H682V558H713V527Z" fill="black" />
        <path d="M775 527H744V558H775V527Z" fill="black" />
        <path d="M806 527H775V558H806V527Z" fill="black" />
        <path d="M868 527H837V558H868V527Z" fill="black" />
        <path d="M930 527H899V558H930V527Z" fill="black" />
        <path d="M992 527H961V558H992V527Z" fill="black" />
        <path d="M1023 527H992V558H1023V527Z" fill="black" />
        <path d="M1085 527H1054V558H1085V527Z" fill="black" />
        <path d="M155 558H124V589H155V558Z" fill="black" />
        <path d="M217 558H186V589H217V558Z" fill="black" />
        <path d="M279 558H248V589H279V558Z" fill="black" />
        <path d="M341 558H310V589H341V558Z" fill="black" />
        <path d="M558 558H527V589H558V558Z" fill="black" />
        <path d="M713 558H682V589H713V558Z" fill="black" />
        <path d="M775 558H744V589H775V558Z" fill="black" />
        <path d="M868 558H837V589H868V558Z" fill="black" />
        <path d="M899 558H868V589H899V558Z" fill="black" />
        <path d="M930 558H899V589H930V558Z" fill="black" />
        <path d="M961 558H930V589H961V558Z" fill="black" />
        <path d="M992 558H961V589H992V558Z" fill="black" />
        <path d="M124 589H93V620H124V589Z" fill="black" />
        <path d="M186 589H155V620H186V589Z" fill="black" />
        <path d="M310 589H279V620H310V589Z" fill="black" />
        <path d="M403 589H372V620H403V589Z" fill="black" />
        <path d="M496 589H465V620H496V589Z" fill="black" />
        <path d="M558 589H527V620H558V589Z" fill="black" />
        <path d="M620 589H589V620H620V589Z" fill="black" />
        <path d="M651 589H620V620H651V589Z" fill="black" />
        <path d="M682 589H651V620H682V589Z" fill="black" />
        <path d="M713 589H682V620H713V589Z" fill="black" />
        <path d="M868 589H837V620H868V589Z" fill="black" />
        <path d="M899 589H868V620H899V589Z" fill="black" />
        <path d="M961 589H930V620H961V589Z" fill="black" />
        <path d="M1023 589H992V620H1023V589Z" fill="black" />
        <path d="M1085 589H1054V620H1085V589Z" fill="black" />
        <path d="M124 620H93V651H124V620Z" fill="black" />
        <path d="M186 620H155V651H186V620Z" fill="black" />
        <path d="M217 620H186V651H217V620Z" fill="black" />
        <path d="M248 620H217V651H248V620Z" fill="black" />
        <path d="M279 620H248V651H279V620Z" fill="black" />
        <path d="M341 620H310V651H341V620Z" fill="black" />
        <path d="M465 620H434V651H465V620Z" fill="black" />
        <path d="M496 620H465V651H496V620Z" fill="black" />
        <path d="M558 620H527V651H558V620Z" fill="black" />
        <path d="M589 620H558V651H589V620Z" fill="black" />
        <path d="M620 620H589V651H620V620Z" fill="black" />
        <path d="M651 620H620V651H651V620Z" fill="black" />
        <path d="M682 620H651V651H682V620Z" fill="black" />
        <path d="M713 620H682V651H713V620Z" fill="black" />
        <path d="M744 620H713V651H744V620Z" fill="black" />
        <path d="M775 620H744V651H775V620Z" fill="black" />
        <path d="M806 620H775V651H806V620Z" fill="black" />
        <path d="M930 620H899V651H930V620Z" fill="black" />
        <path d="M992 620H961V651H992V620Z" fill="black" />
        <path d="M1023 620H992V651H1023V620Z" fill="black" />
        <path d="M1085 620H1054V651H1085V620Z" fill="black" />
        <path d="M124 651H93V682H124V651Z" fill="black" />
        <path d="M155 651H124V682H155V651Z" fill="black" />
        <path d="M186 651H155V682H186V651Z" fill="black" />
        <path d="M217 651H186V682H217V651Z" fill="black" />
        <path d="M310 651H279V682H310V651Z" fill="black" />
        <path d="M465 651H434V682H465V651Z" fill="black" />
        <path d="M558 651H527V682H558V651Z" fill="black" />
        <path d="M589 651H558V682H589V651Z" fill="black" />
        <path d="M713 651H682V682H713V651Z" fill="black" />
        <path d="M775 651H744V682H775V651Z" fill="black" />
        <path d="M806 651H775V682H806V651Z" fill="black" />
        <path d="M837 651H806V682H837V651Z" fill="black" />
        <path d="M961 651H930V682H961V651Z" fill="black" />
        <path d="M992 651H961V682H992V651Z" fill="black" />
        <path d="M1023 651H992V682H1023V651Z" fill="black" />
        <path d="M124 682H93V713H124V682Z" fill="black" />
        <path d="M186 682H155V713H186V682Z" fill="black" />
        <path d="M217 682H186V713H217V682Z" fill="black" />
        <path d="M279 682H248V713H279V682Z" fill="black" />
        <path d="M310 682H279V713H310V682Z" fill="black" />
        <path d="M341 682H310V713H341V682Z" fill="black" />
        <path d="M434 682H403V713H434V682Z" fill="black" />
        <path d="M465 682H434V713H465V682Z" fill="black" />
        <path d="M496 682H465V713H496V682Z" fill="black" />
        <path d="M527 682H496V713H527V682Z" fill="black" />
        <path d="M589 682H558V713H589V682Z" fill="black" />
        <path d="M651 682H620V713H651V682Z" fill="black" />
        <path d="M682 682H651V713H682V682Z" fill="black" />
        <path d="M744 682H713V713H744V682Z" fill="black" />
        <path d="M775 682H744V713H775V682Z" fill="black" />
        <path d="M837 682H806V713H837V682Z" fill="black" />
        <path d="M930 682H899V713H930V682Z" fill="black" />
        <path d="M992 682H961V713H992V682Z" fill="black" />
        <path d="M1085 682H1054V713H1085V682Z" fill="black" />
        <path d="M93 713H62V744H93V713Z" fill="black" />
        <path d="M155 713H124V744H155V713Z" fill="black" />
        <path d="M186 713H155V744H186V713Z" fill="black" />
        <path d="M217 713H186V744H217V713Z" fill="black" />
        <path d="M248 713H217V744H248V713Z" fill="black" />
        <path d="M310 713H279V744H310V713Z" fill="black" />
        <path d="M341 713H310V744H341V713Z" fill="black" />
        <path d="M372 713H341V744H372V713Z" fill="black" />
        <path d="M465 713H434V744H465V713Z" fill="black" />
        <path d="M496 713H465V744H496V713Z" fill="black" />
        <path d="M620 713H589V744H620V713Z" fill="black" />
        <path d="M806 713H775V744H806V713Z" fill="black" />
        <path d="M961 713H930V744H961V713Z" fill="black" />
        <path d="M1023 713H992V744H1023V713Z" fill="black" />
        <path d="M93 744H62V775H93V744Z" fill="black" />
        <path d="M186 744H155V775H186V744Z" fill="black" />
        <path d="M248 744H217V775H248V744Z" fill="black" />
        <path d="M279 744H248V775H279V744Z" fill="black" />
        <path d="M310 744H279V775H310V744Z" fill="black" />
        <path d="M341 744H310V775H341V744Z" fill="black" />
        <path d="M403 744H372V775H403V744Z" fill="black" />
        <path d="M434 744H403V775H434V744Z" fill="black" />
        <path d="M465 744H434V775H465V744Z" fill="black" />
        <path d="M496 744H465V775H496V744Z" fill="black" />
        <path d="M527 744H496V775H527V744Z" fill="black" />
        <path d="M620 744H589V775H620V744Z" fill="black" />
        <path d="M651 744H620V775H651V744Z" fill="black" />
        <path d="M682 744H651V775H682V744Z" fill="black" />
        <path d="M713 744H682V775H713V744Z" fill="black" />
        <path d="M744 744H713V775H744V744Z" fill="black" />
        <path d="M806 744H775V775H806V744Z" fill="black" />
        <path d="M868 744H837V775H868V744Z" fill="black" />
        <path d="M899 744H868V775H899V744Z" fill="black" />
        <path d="M1054 744H1023V775H1054V744Z" fill="black" />
        <path d="M1085 744H1054V775H1085V744Z" fill="black" />
        <path d="M93 775H62V806H93V775Z" fill="black" />
        <path d="M155 775H124V806H155V775Z" fill="black" />
        <path d="M403 775H372V806H403V775Z" fill="black" />
        <path d="M496 775H465V806H496V775Z" fill="black" />
        <path d="M527 775H496V806H527V775Z" fill="black" />
        <path d="M558 775H527V806H558V775Z" fill="black" />
        <path d="M620 775H589V806H620V775Z" fill="black" />
        <path d="M682 775H651V806H682V775Z" fill="black" />
        <path d="M713 775H682V806H713V775Z" fill="black" />
        <path d="M775 775H744V806H775V775Z" fill="black" />
        <path d="M806 775H775V806H806V775Z" fill="black" />
        <path d="M837 775H806V806H837V775Z" fill="black" />
        <path d="M930 775H899V806H930V775Z" fill="black" />
        <path d="M1023 775H992V806H1023V775Z" fill="black" />
        <path d="M1054 775H1023V806H1054V775Z" fill="black" />
        <path d="M1085 775H1054V806H1085V775Z" fill="black" />
        <path d="M93 806H62V837H93V806Z" fill="black" />
        <path d="M124 806H93V837H124V806Z" fill="black" />
        <path d="M155 806H124V837H155V806Z" fill="black" />
        <path d="M248 806H217V837H248V806Z" fill="black" />
        <path d="M279 806H248V837H279V806Z" fill="black" />
        <path d="M310 806H279V837H310V806Z" fill="black" />
        <path d="M434 806H403V837H434V806Z" fill="black" />
        <path d="M465 806H434V837H465V806Z" fill="black" />
        <path d="M496 806H465V837H496V806Z" fill="black" />
        <path d="M527 806H496V837H527V806Z" fill="black" />
        <path d="M589 806H558V837H589V806Z" fill="black" />
        <path d="M651 806H620V837H651V806Z" fill="black" />
        <path d="M775 806H744V837H775V806Z" fill="black" />
        <path d="M837 806H806V837H837V806Z" fill="black" />
        <path d="M868 806H837V837H868V806Z" fill="black" />
        <path d="M899 806H868V837H899V806Z" fill="black" />
        <path d="M930 806H899V837H930V806Z" fill="black" />
        <path d="M961 806H930V837H961V806Z" fill="black" />
        <path d="M992 806H961V837H992V806Z" fill="black" />
        <path d="M1054 806H1023V837H1054V806Z" fill="black" />
        <path d="M341 837H310V868H341V837Z" fill="black" />
        <path d="M372 837H341V868H372V837Z" fill="black" />
        <path d="M496 837H465V868H496V837Z" fill="black" />
        <path d="M558 837H527V868H558V837Z" fill="black" />
        <path d="M589 837H558V868H589V837Z" fill="black" />
        <path d="M620 837H589V868H620V837Z" fill="black" />
        <path d="M651 837H620V868H651V837Z" fill="black" />
        <path d="M744 837H713V868H744V837Z" fill="black" />
        <path d="M806 837H775V868H806V837Z" fill="black" />
        <path d="M837 837H806V868H837V837Z" fill="black" />
        <path d="M961 837H930V868H961V837Z" fill="black" />
        <path d="M1023 837H992V868H1023V837Z" fill="black" />
        <path d="M1054 837H1023V868H1054V837Z" fill="black" />
        <path d="M341 868H310V899H341V868Z" fill="black" />
        <path d="M403 868H372V899H403V868Z" fill="black" />
        <path d="M434 868H403V899H434V868Z" fill="black" />
        <path d="M558 868H527V899H558V868Z" fill="black" />
        <path d="M620 868H589V899H620V868Z" fill="black" />
        <path d="M682 868H651V899H682V868Z" fill="black" />
        <path d="M713 868H682V899H713V868Z" fill="black" />
        <path d="M806 868H775V899H806V868Z" fill="black" />
        <path d="M837 868H806V899H837V868Z" fill="black" />
        <path d="M899 868H868V899H899V868Z" fill="black" />
        <path d="M961 868H930V899H961V868Z" fill="black" />
        <path d="M1023 868H992V899H1023V868Z" fill="black" />
        <path d="M341 899H310V930H341V899Z" fill="black" />
        <path d="M434 899H403V930H434V899Z" fill="black" />
        <path d="M496 899H465V930H496V899Z" fill="black" />
        <path d="M527 899H496V930H527V899Z" fill="black" />
        <path d="M589 899H558V930H589V899Z" fill="black" />
        <path d="M620 899H589V930H620V899Z" fill="black" />
        <path d="M651 899H620V930H651V899Z" fill="black" />
        <path d="M682 899H651V930H682V899Z" fill="black" />
        <path d="M713 899H682V930H713V899Z" fill="black" />
        <path d="M744 899H713V930H744V899Z" fill="black" />
        <path d="M775 899H744V930H775V899Z" fill="black" />
        <path d="M806 899H775V930H806V899Z" fill="black" />
        <path d="M837 899H806V930H837V899Z" fill="black" />
        <path d="M961 899H930V930H961V899Z" fill="black" />
        <path d="M992 899H961V930H992V899Z" fill="black" />
        <path d="M1023 899H992V930H1023V899Z" fill="black" />
        <path d="M1054 899H1023V930H1054V899Z" fill="black" />
        <path d="M1085 899H1054V930H1085V899Z" fill="black" />
        <path d="M341 930H310V961H341V930Z" fill="black" />
        <path d="M372 930H341V961H372V930Z" fill="black" />
        <path d="M496 930H465V961H496V930Z" fill="black" />
        <path d="M589 930H558V961H589V930Z" fill="black" />
        <path d="M620 930H589V961H620V930Z" fill="black" />
        <path d="M744 930H713V961H744V930Z" fill="black" />
        <path d="M775 930H744V961H775V930Z" fill="black" />
        <path d="M806 930H775V961H806V930Z" fill="black" />
        <path d="M837 930H806V961H837V930Z" fill="black" />
        <path d="M868 930H837V961H868V930Z" fill="black" />
        <path d="M899 930H868V961H899V930Z" fill="black" />
        <path d="M930 930H899V961H930V930Z" fill="black" />
        <path d="M961 930H930V961H961V930Z" fill="black" />
        <path d="M341 961H310V992H341V961Z" fill="black" />
        <path d="M403 961H372V992H403V961Z" fill="black" />
        <path d="M496 961H465V992H496V961Z" fill="black" />
        <path d="M527 961H496V992H527V961Z" fill="black" />
        <path d="M589 961H558V992H589V961Z" fill="black" />
        <path d="M651 961H620V992H651V961Z" fill="black" />
        <path d="M744 961H713V992H744V961Z" fill="black" />
        <path d="M775 961H744V992H775V961Z" fill="black" />
        <path d="M837 961H806V992H837V961Z" fill="black" />
        <path d="M868 961H837V992H868V961Z" fill="black" />
        <path d="M930 961H899V992H930V961Z" fill="black" />
        <path d="M1085 961H1054V992H1085V961Z" fill="black" />
        <path d="M403 992H372V1023H403V992Z" fill="black" />
        <path d="M465 992H434V1023H465V992Z" fill="black" />
        <path d="M558 992H527V1023H558V992Z" fill="black" />
        <path d="M682 992H651V1023H682V992Z" fill="black" />
        <path d="M837 992H806V1023H837V992Z" fill="black" />
        <path d="M868 992H837V1023H868V992Z" fill="black" />
        <path d="M930 992H899V1023H930V992Z" fill="black" />
        <path d="M961 992H930V1023H961V992Z" fill="black" />
        <path d="M1054 992H1023V1023H1054V992Z" fill="black" />
        <path d="M1085 992H1054V1023H1085V992Z" fill="black" />
        <path d="M403 1023H372V1054H403V1023Z" fill="black" />
        <path d="M434 1023H403V1054H434V1023Z" fill="black" />
        <path d="M496 1023H465V1054H496V1023Z" fill="black" />
        <path d="M527 1023H496V1054H527V1023Z" fill="black" />
        <path d="M651 1023H620V1054H651V1023Z" fill="black" />
        <path d="M682 1023H651V1054H682V1023Z" fill="black" />
        <path d="M713 1023H682V1054H713V1023Z" fill="black" />
        <path d="M899 1023H868V1054H899V1023Z" fill="black" />
        <path d="M930 1023H899V1054H930V1023Z" fill="black" />
        <path d="M961 1023H930V1054H961V1023Z" fill="black" />
        <path d="M992 1023H961V1054H992V1023Z" fill="black" />
        <path d="M1023 1023H992V1054H1023V1023Z" fill="black" />
        <path d="M1054 1023H1023V1054H1054V1023Z" fill="black" />
        <path d="M1085 1023H1054V1054H1085V1023Z" fill="black" />
        <path d="M341 1054H310V1085H341V1054Z" fill="black" />
        <path d="M372 1054H341V1085H372V1054Z" fill="black" />
        <path d="M403 1054H372V1085H403V1054Z" fill="black" />
        <path d="M434 1054H403V1085H434V1054Z" fill="black" />
        <path d="M496 1054H465V1085H496V1054Z" fill="black" />
        <path d="M558 1054H527V1085H558V1054Z" fill="black" />
        <path d="M589 1054H558V1085H589V1054Z" fill="black" />
        <path d="M620 1054H589V1085H620V1054Z" fill="black" />
        <path d="M682 1054H651V1085H682V1054Z" fill="black" />
        <path d="M806 1054H775V1085H806V1054Z" fill="black" />
        <path d="M837 1054H806V1085H837V1054Z" fill="black" />
        <path d="M899 1054H868V1085H899V1054Z" fill="black" />
        <path d="M930 1054H899V1085H930V1054Z" fill="black" />
        <path d="M961 1054H930V1085H961V1054Z" fill="black" />
        <path
          d="M62 62V279H279V62H62ZM246.45 246.45H94.55V94.55H246.45V246.45Z"
          fill="black"
        />
        <path
          d="M868 62V279H1085V62H868ZM1052.45 246.45H900.55V94.55H1052.45V246.45Z"
          fill="black"
        />
        <path
          d="M62 868V1085H279V868H62ZM246.45 1052.45H94.55V900.55H246.45V1052.45Z"
          fill="black"
        />
        <path d="M217 124H124V217H217V124Z" fill="black" />
        <path d="M1023 124H930V217H1023V124Z" fill="black" />
        <path d="M217 930H124V1023H217V930Z" fill="black" />
        <path d="M341 62H310V93H341V62Z" fill="black" />
        <path d="M372 62H341V93H372V62Z" fill="black" />
        <path d="M403 62H372V93H403V62Z" fill="black" />
        <path d="M434 62H403V93H434V62Z" fill="black" />
        <path d="M496 62H465V93H496V62Z" fill="black" />
        <path d="M527 62H496V93H527V62Z" fill="black" />
        <path d="M620 62H589V93H620V62Z" fill="black" />
        <path d="M651 62H620V93H651V62Z" fill="black" />
        <path d="M713 62H682V93H713V62Z" fill="black" />
        <path d="M744 62H713V93H744V62Z" fill="black" />
        <path d="M775 62H744V93H775V62Z" fill="black" />
      </svg>
    </div>
  );
};

export default TestServerQR1;
